/* eslint-disable no-restricted-syntax */
/* eslint-disable no-prototype-builtins */
import numeral from 'numeral';
import { isBlank } from 'adready-api/helpers/common';
import moment from 'moment';

import {
  DATE_FILTER,
  VISITS,
  CURRENCY,
  PERCENTAGE,
  DECIMAL_PERCENTAGE,
  FREQUENCY,
  DECIMAL,
  DEMO_DOMAIN_PART,
  RANGE_CUSTOM,
  RANGE_CAMPAIGN_TO_DATE,
  SEARCH_SOLUTION_ID,
  META_SOLUTION_ID,
  CONVERGED_TV_SOLUTION_ID,
  CAMPAIGN_FILTER,
  ADGROUP_FILTER,
  PIXEL_FILTER,
  ADVANCED_FILTER,
  MEDIATYPE_FILTER,
  CREATIVE_FILTER,
  AUDIENCE_FILTER,
  AD_FILTER,
  KEYWORD_FILTER,
  CONVERSION_WINDOW_FILTER,
  EMAIL_VALIDATION_REGEX,
  VIA_ACCOUNT_ID,
  labelConfig,
  APPLICATION_AI_ASSISTANT_FULL_PLATFORM,
  debug,
  MNI_MOTTO_SOLUTION_ID,
  GENERIC_ERROR_MESSAGE,
  GENERIC_REPORT_GATEWAY_TIMEOUT_ERROR_MESSAGE,
} from '@/constant';
import html2pdf from 'html2pdf.js';
import formatNumber, { formatNumberAsFullNumber } from '~/util/numeral';
import { formatDate } from '~/util/apiDateFormat';
import { resolvedConfig } from './shared-config';

const VALUE_FORMAT_MAPPING = {
  impressions: VISITS,
  spend: CURRENCY,
  cpm: CURRENCY,
  visits: VISITS,
  cpa: CURRENCY,
  revenue: CURRENCY,
  roas: PERCENTAGE,
  frequency: FREQUENCY,
  pm: DECIMAL,
  reach: '',
  incrementalreachpercentage: DECIMAL_PERCENTAGE,
  incrementality: PERCENTAGE,
  brandlift: PERCENTAGE,
  vcr: PERCENTAGE,
  videoCompletions: VISITS,
  ctr: DECIMAL_PERCENTAGE,
  clicks: VISITS,
  cpc: CURRENCY,
  cpcv: CURRENCY,
};

export function getValueFormat(valueType) {
  if (!valueType) {
    return 'VISITS';
  }
  return VALUE_FORMAT_MAPPING[valueType.toLowerCase()] || 'VISITS';
}

export function toTitleCase(s = '') {
  return s
    .split(' ')
    .map((w) => w[0].toUpperCase() + w.substr(1).toLowerCase())
    .join(' ');
}

export const convertEpochToNYTimezone = (date) => {
  // const d = date ? new Date(date) : new Date();
  // const dTime = d.getTime() + d.getTimezoneOffset() * 60000;
  // const nyTimeString = new Date(dTime).toLocaleString('en-US', { timeZone: 'America/New_York' });
  // const nyTime = new Date(nyTimeString);
  // return nyTime;
  return date;
};

export const offsetDate = (offsetDays) => {
  const newDate = new Date(new Date().setDate(new Date().getDate() - offsetDays));
  return newDate;
};

export const generateDefaultDates = () => {
  const startDate = offsetDate(31);
  const endDate = offsetDate(2);
  const dateRangeOption = '7'; // default dropdown option is last 30 days
  const compareWith = false;
  return { startDate, endDate, dateRangeOption, compareWith };
};

export const generatePixelPageDefaultDates = () => {
  const startDate = new Date(new Date().setDate(new Date().getDate() - 29));
  const endDate = new Date();
  const dateRangeOption = '7'; // default dropdown option is last 30 days
  return { startDate, endDate, dateRangeOption };
};

export const generateFlipDefaultDates = () => {
  const startDate = offsetDate(31);
  const endDate = offsetDate(2);
  const compareStartDate = offsetDate(32);
  const compareEndDate = offsetDate(3);
  const dateRangeOption = '7'; // default dropdown option is last 30 days
  const compareWith = false;
  return { startDate, endDate, compareStartDate, compareEndDate, dateRangeOption, compareWith };
};

// default values when there's no value in the demo accounts list
// this is from dashboard.store.js
export const generateDemoInstanceDates = () => {
  const startDate = new Date(2022, 2, 9);
  const endDate = new Date(2022, 3, 15);
  const compareStartDate = new Date(2022, 2, 9);
  const compareEndDate = new Date(2022, 3, 14);
  return { startDate, endDate, compareStartDate, compareEndDate };
};

export function formatHour(s) {
  let hour = 0;
  if (s === '0') {
    hour = 12;
  } else {
    hour = `${s > 12 ? s - 12 : s}`;
  }
  return `${hour} ${s >= 12 ? 'PM' : 'AM'}`;
}

export const capitalizeStringSentence = (str = '') => {
  if (str !== '') {
    const arr = str.split(' ');
    for (let i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    return arr.join(' ');
  }
  return '';
};

export function formatNumberAsLargeNumber(value, format = '') {
  if (!format) {
    return value;
  }
  const isPercentageFormat = format && format.endsWith('%');
  const valueClone = isPercentageFormat ? value / 100 : value;
  const num = numeral(valueClone);
  return num.format(format);
}

export function formatFileSize(bytes) {
  if (bytes === 0) {
    return '0.00 B';
  }
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const units = ['B', 'kB', 'MB', 'GB', 'TB'];
  return `${(bytes / 1024 ** i).toFixed(2) * 1} ${units[i]}`;
}

export function insertAt(array, index, ...elements) {
  array.splice(index, 0, ...elements);
}

export function isAnyBlank(object, fieldList) {
  for (let i = 0; i < fieldList.length; i++) {
    if (isBlank(object[fieldList[i]])) {
      return true;
    }
  }
  return false;
}

export function getDomainPartsFromHost(hostname) {
  const host = hostname;
  const domainParts = host.split('.');
  const subDomain = domainParts.shift();
  const rootDomain = domainParts.join('.');
  return { host, subDomain, rootDomain };
}

export function isDemoInstance() {
  const { subDomain } = getDomainPartsFromHost(window.location.hostname);
  return subDomain.toLowerCase().includes(`${DEMO_DOMAIN_PART}-`) || subDomain === DEMO_DOMAIN_PART;
}

export function isFlamingoInstance() {
  const { subDomain } = getDomainPartsFromHost(window.location.hostname);
  return subDomain.toLowerCase().includes('flamingo');
}

export function toFixedNumber(num, digits) {
  if (digits === 0) {
    return Math.round(num);
  }
  const pow = 10 ** digits;
  return Math.round(num * pow) / pow;
}

export function dateDiff(s, e) {
  if (isBlank(s) || isBlank(e)) {
    return 0;
  }
  const startDate = moment(s);
  const endDate = moment(e);
  return endDate.diff(startDate, 'days');
}

export function isAdvertiserSetupCompleted(advertiser) {
  if (!advertiser?.selfServe) {
    return true;
  }

  const accountSetup =
    advertiser &&
    advertiser.selfServe &&
    advertiser.accountSetup &&
    advertiser.accountSetup.accountInfoAvailable &&
    advertiser.accountSetup.paymentInfoAvailable;

  return accountSetup;
}

export function formatMetricValue(label, value, includeLabel = false) {
  if (isBlank(label) && label !== 'REACH') {
    return '';
  }
  if (isBlank(value)) {
    value = 0;
  }
  const displayLabel = label.toUpperCase();
  if (label === 'REACH' && includeLabel === true) {
    return displayLabel;
  }
  const valueType = getValueFormat(label);
  const val =
    label === 'ROAS' || label === 'VCR'
      ? formatNumber(value, valueType)
      : formatNumberAsFullNumber(value, valueType);
  return includeLabel ? `${displayLabel}: ${val}` : val;
}

export function scrollToElement(elementId, alignTo = 'top') {
  const el = document.getElementById(elementId);
  if (!el) {
    return;
  }

  if (alignTo === 'top') {
    el.scrollIntoView(true);
    return;
  }

  el.scrollIntoView();
}

export function deepEqual(obj1, obj2) {
  // Check if both arguments are objects
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return obj1 === obj2; // Compare primitive values directly
  }

  // Check if both objects are null (since typeof null === 'object')
  if (obj1 === null && obj2 === null) {
    return true;
  }

  // Check if one object is null and the other is not
  if (obj1 === null || obj2 === null) {
    return false;
  }

  // Get the keys of both objects
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // Check if the number of keys is the same
  if (keys1.length !== keys2.length) {
    return false;
  }

  // Check if all keys and values are equal
  // eslint-disable-next-line no-restricted-syntax
  for (const key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}

export function formatFlipDate(date, dateFormat = 'yyyy-MM-DD') {
  return !isBlank(date) ? moment(new Date(date)).format(dateFormat) : '';
}

export function addDaysToDate(date, count) {
  date.setDate(date.getDate() + count);
  return date;
}

export function jsonArrayToCsv(array) {
  const header = Object.keys(array[0]);

  // handle null or undefined values here
  const replacer = (key, value) => value ?? '';

  const rows = array.map((row) =>
    header.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(',')
  );

  // join header and body, and break into separate lines
  const csv = rows.join('\r\n');
  return csv;
}

export function downloadCSVFile(items, fileName = 'export.csv') {
  const downloadFileName = fileName.replace(/ /g, '_').toLowerCase();
  const csv = jsonArrayToCsv(items);

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, downloadFileName);
  } else {
    const link = document.createElement('a');
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', downloadFileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}

export const getCampaignDateRange = (campaigns = [], decideEndDate = false) => {
  let selectedCampaigns = campaigns.filter((val) => val.checked);
  if (!selectedCampaigns.length) {
    selectedCampaigns = campaigns;
  }
  const startDates = selectedCampaigns.map((filterVal) => filterVal.startDate);
  const minStartDate = startDates.sort()[0];
  let endDate = new Date(new Date().setDate(new Date().getDate() - 1));
  let dateRangeOption = RANGE_CAMPAIGN_TO_DATE;

  if (decideEndDate) {
    const endDates = selectedCampaigns.map((filterVal) => filterVal.endDate);
    let maxEndDate = endDates.sort().reverse()[0];
    const yesterday = formatDate(endDate);
    if (maxEndDate >= yesterday) {
      maxEndDate = yesterday;
    } else {
      dateRangeOption = RANGE_CUSTOM;
    }
    endDate = new Date(maxEndDate);
  }
  const compareEndDate = new Date(new Date(endDate).setDate(endDate.getDate() - 1));
  const notAvailable = minStartDate === undefined || endDate === undefined;
  return {
    startDate:
      minStartDate !== undefined ? convertEpochToNYTimezone(new Date(minStartDate)) : minStartDate,
    endDate: endDate !== undefined ? convertEpochToNYTimezone(endDate) : minStartDate,
    dateRangeOption,
    compareStartDate:
      minStartDate !== undefined ? convertEpochToNYTimezone(new Date(minStartDate)) : minStartDate,
    compareEndDate:
      compareEndDate !== undefined ? convertEpochToNYTimezone(compareEndDate) : compareEndDate,
    notAvailable,
  };
};

export function isFormattedValueZero(formattedVal) {
  const val = formattedVal
    .replace('.', '')
    .replace(/0/g, '')
    .replace('%', '')
    .replace('$', '')
    .replace(/,/g, '');
  return isBlank(val);
}

export function convertToNumber(formattedVal) {
  const val = formattedVal
    .replace('%', '')
    .replace('$', '')
    .replace(/,/g, '');
  return +val;
}

export function filterAccountsAndAdvertisersForDemo(userAccounts, accountKeys, advertiserKeys) {
  // if (!isDemoInstance()) {
  //  return userAccounts;
  // }

  const userAccountsCopy = JSON.parse(JSON.stringify(userAccounts));

  userAccountsCopy.forEach((ua) => {
    const filteredAdvertisers = ua?.advertisers.filter((adv) => {
      const included = advertiserKeys.includes(adv.id);
      return isDemoInstance() ? included : !included;
    });
    ua.advertisers = filteredAdvertisers ? JSON.parse(JSON.stringify(filteredAdvertisers)) : [];
  });

  const filteredUserAccounts = userAccountsCopy.filter((ua) => {
    const included = accountKeys.includes(ua.id);
    if (isDemoInstance()) {
      return included;
    }
    if (included && Array.isArray(ua?.advertisers) && ua.advertisers.length > 0) {
      return true;
    }
    return !included;
  });

  return filteredUserAccounts;
}

export function getFiltersToHide(solution, tool, dashboard, dashboardTab) {
  const listOfFiltersToHide = [];

  if (solution?.id === SEARCH_SOLUTION_ID) {
    listOfFiltersToHide.push(PIXEL_FILTER);
    if (['geo', 'report'].includes(dashboardTab)) {
      listOfFiltersToHide.push(ADVANCED_FILTER);
    } else {
      listOfFiltersToHide.push(
        ...[MEDIATYPE_FILTER, CREATIVE_FILTER, AUDIENCE_FILTER, CONVERSION_WINDOW_FILTER]
      );
      if (dashboardTab === 'ads') {
        listOfFiltersToHide.push(KEYWORD_FILTER);
      } else if (dashboardTab === 'keywords') {
        listOfFiltersToHide.push(AD_FILTER);
      }
    }
  } else if (solution?.id === META_SOLUTION_ID) {
    if (['placement', 'report'].includes(dashboardTab)) {
      listOfFiltersToHide.push(ADVANCED_FILTER);
    } else {
      listOfFiltersToHide.push(
        ...[
          MEDIATYPE_FILTER,
          CREATIVE_FILTER,
          AUDIENCE_FILTER,
          CONVERSION_WINDOW_FILTER,
          KEYWORD_FILTER,
        ]
      );
    }
  } else if (solution?.id === CONVERGED_TV_SOLUTION_ID) {
    listOfFiltersToHide.push(PIXEL_FILTER);
    if (['overview'].includes(dashboardTab)) {
      listOfFiltersToHide.push(...[AD_FILTER, KEYWORD_FILTER, ADVANCED_FILTER]);
    } else if (['measurement'].includes(dashboardTab)) {
      listOfFiltersToHide.push(...[AD_FILTER, KEYWORD_FILTER]);
    } else if (['conversions'].includes(dashboardTab)) {
      listOfFiltersToHide.push(
        ...[
          CAMPAIGN_FILTER,
          ADGROUP_FILTER,
          MEDIATYPE_FILTER,
          CREATIVE_FILTER,
          AUDIENCE_FILTER,
          AD_FILTER,
          KEYWORD_FILTER,
        ]
      );
    } else {
      listOfFiltersToHide.push(...[CAMPAIGN_FILTER, ADGROUP_FILTER, ADVANCED_FILTER]);
    }
  } else if (solution?.id === MNI_MOTTO_SOLUTION_ID) {
    listOfFiltersToHide.push(PIXEL_FILTER);
    if (['journeyanalytics'].includes(dashboardTab)) {
      listOfFiltersToHide.push(
        ...[
          ADGROUP_FILTER,
          MEDIATYPE_FILTER,
          CREATIVE_FILTER,
          AD_FILTER,
          KEYWORD_FILTER,
          CONVERSION_WINDOW_FILTER,
        ]
      );
    } else {
      listOfFiltersToHide.push(...[AD_FILTER, KEYWORD_FILTER, CONVERSION_WINDOW_FILTER]);
    }
  } else if (tool?.title === 'Custom Reports' || tool?.title === 'Agency Reports') {
    listOfFiltersToHide.push(PIXEL_FILTER);
    listOfFiltersToHide.push(DATE_FILTER);
  } else {
    listOfFiltersToHide.push(...[AD_FILTER, KEYWORD_FILTER, CONVERSION_WINDOW_FILTER]);
  }
  return listOfFiltersToHide;
}

export function isFilterOptionDisabled(filtersToHide, option) {
  return filtersToHide && filtersToHide?.length > 0 && filtersToHide?.includes(option);
}

export function isFilterOptionEnabled(filtersToHide, option) {
  return !isFilterOptionDisabled(filtersToHide, option);
}

export function checkForDisablingConversions(dimension) {
  return (
    dimension === 'country' ||
    dimension === 'state' ||
    dimension === 'dma' ||
    dimension === 'device'
  );
}

export function isEmailValid(email) {
  if (!email) {
    return false;
  }
  return email.match(EMAIL_VALIDATION_REGEX);
}

export function isViaAccount(accountId) {
  if (accountId === VIA_ACCOUNT_ID) return true;
  return false;
}

// this function does deep merge operation on label config constants with account level labels and default labels
export function deepMerge(target, source) {
  for (const key in source) {
    if (source.hasOwnProperty(key)) {
      if (typeof source[key] === 'object' && !Array.isArray(source[key])) {
        if (!target[key]) {
          target[key] = {};
        }
        deepMerge(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    }
  }
  return target;
}

//  getLabel() is function that returs the component specific and account level labels to shown in app
export function getLabel(componentName, accountId) {
  const componentConfig = labelConfig[componentName];
  if (!componentConfig) {
    throw new Error(`Invalid component name: ${componentName}`);
  }

  const { defaultLabel, accountIdSpecificLabel } = componentConfig;
  const accountConfig = accountIdSpecificLabel[accountId] || {};
  return deepMerge({ ...defaultLabel }, accountConfig);
}

function deepMerge2Arrays(baseOptions, accountOptions) {
  const merged = [...baseOptions];
  accountOptions.forEach((accountOption) => {
    const index = merged.findIndex((baseOption) => baseOption.id === accountOption.id);

    if (index !== -1) {
      merged[index] = { ...merged[index], ...accountOption };
    } else {
      merged.push(accountOption);
    }
  });

  return merged;
}

function deepMerge2Objects(baseOptions, accountOptions) {
  const merged = { ...baseOptions };
  for (const key in accountOptions) {
    if (accountOptions.hasOwnProperty(key)) {
      merged[key] = accountOptions[key];
    }
  }
  return merged;
}

// getCorrectLabels is function that returns  solution specific and account  level labels to be displayed.
export function getCorrectLabels(baseOptions, accountOptions) {
  if (!accountOptions) return baseOptions;

  if (Array.isArray(baseOptions) && Array.isArray(accountOptions)) {
    return deepMerge2Arrays(baseOptions, accountOptions);
  }
  return deepMerge2Objects(baseOptions, accountOptions);
}

export function formatAPDate(date, dateFormat = 'yyyy-MM-DD') {
  return !isBlank(date) ? moment(new Date(date)).format(dateFormat) : '';
}

export function compareArrays(a, b) {
  a = a.sort();
  b = b.sort();
  return a.length === b.length && a.every((element, index) => element === b[index]);
}

export function formatViamediaName(name) {
  if (name && name.toLowerCase() === 'Viamedia'.toLowerCase()) {
    return 'VIA Media 2021';
  }
  return name;
}

export function getSanitizedId(option, child = null) {
  // Sanitize option.title and child.title, then combine them
  if (child !== null) {
    return `${this.sanitizeTitle(option.title)}-${this.sanitizeTitle(child.title)}`;
  }
  return `${this.sanitizeTitle(option.title)}`;
}

export function sanitizeTitle(title) {
  // Regex to remove any non-alphanumeric characters, spaces, and special symbols
  return title.replace(/[^a-zA-Z0-9_-]/g, '');
}
export function pageExportToPDF(elementId, orientation = 'portrait', groupByValue = '') {
  const element = document.getElementById(elementId);

  if (!element) {
    console.error(`Element with ID ${elementId} not found.`);
    return;
  }

  // Clone the element for modifications
  const clonedElement = element.cloneNode(true);
  clonedElement.style.width = '100%'; // A4 width
  clonedElement.style.height = 'auto'; // Auto adjust height
  clonedElement.style.fontSize = '12px'; // Adjust font size for better fit

  // Modifications to the clone
  const modal = clonedElement.querySelector('.download-options-modal');
  if (modal) {
    modal.style.display = 'none'; // Hide the modal
  }

  const divdata = clonedElement.querySelector('.panel_scroll_wrap');
  if (divdata) {
    divdata.style.height = 'auto';
    divdata.style.maxHeight = 'auto';
  }

  const selectors = [
    '.inc-canvas',
    '.donut-legend',
    '.donut-container table',
    'donut-legend-table-div',
  ];

  selectors.forEach((selector) => {
    const elements = clonedElement.querySelectorAll(selector);
    elements.forEach((el) => {
      el.style.height = 'auto';
      el.style.maxHeight = 'none';
      el.style.overflow = 'visible';
    });
  });

  // Fix the map container dimensions
  const mapContainer = clonedElement.querySelector('.container-chart'); // Correct map container selector
  if (mapContainer && groupByValue.includes('state', 'dma')) {
    mapContainer.style.height = '456px'; // Custom height to accommodate all content
    mapContainer.style.width = '633px'; // Custom min-width to accommodate all content
    mapContainer.style.overflow = 'visible'; // Ensure it doesn't hide overflowing content
  }

  // Fix the map legend dimensions
  const mapLegend = clonedElement.querySelector('.legends'); // Correct maplegend selector
  if (mapLegend) {
    mapLegend.style.height = '40px'; // Custom height to accommodate all content
    mapLegend.style.width = '350px'; // Custom width to accommodate all content
    mapLegend.style.overflow = 'visible'; // Ensure it doesn't hide overflowing content
  }

  // Handle specific styles for #legend-title
  const legends = clonedElement.querySelectorAll('#legend-title');
  legends.forEach((title) => {
    title.style.whiteSpace = 'normal'; // Allow text wrapping
    title.style.wordWrap = 'break-word'; // Break long words
    title.style.overflow = 'visible'; // Ensure no clipping of text
    title.style.textOverflow = 'unset'; // Remove ellipses
  });
  // Select all the .tg-0lax elements inside .two-thirds .tg
  const tgElements = clonedElement.querySelectorAll('.two-thirds .tg .tg-0lax');

  // Iterate through the selected elements and modify their styles
  tgElements.forEach((element1) => {
    element1.style.whiteSpace = 'pre-wrap'; // Change white-space to pre-wrap
    element1.style.overflow = 'visible'; // Remove overflow hidden (if needed)
    element1.style.textOverflow = 'unset'; // Remove text-overflow (if needed)
  });
  // Adjust the donut-container .donut-legend style for PDF export
  const donutLegendContainer = clonedElement.querySelector('.donut-container .donut-legend');
  if (donutLegendContainer) {
    donutLegendContainer.style.overflowY = 'visible'; // Remove scroll, allow content to stretch
    donutLegendContainer.style.height = 'auto'; // Ensure it grows with content
    donutLegendContainer.style.maxHeight = 'none'; // Remove any max height constraints
  }
  // Adjust text positioning inside .donut-container .donut-legend tr
  const legendTextRows = clonedElement.querySelectorAll('.donut-container .donut-legend tr');
  legendTextRows.forEach((row) => {
    row.style.transform = 'translateY(-15px)'; // Moves text up by 5px (adjust value as needed)
    row.style.lineHeight = '1'; // Adjust line height if necessary
  });

  // Ensure the parent container is flexible
  const parentContainer = clonedElement.querySelector('.donut-container'); // Correct parent container selector
  if (parentContainer) {
    parentContainer.style.height = 'auto'; // Auto height to accommodate all content
    parentContainer.style.overflow = 'visible'; // Ensure it doesn't hide overflowing content
  }
  const metricDistributionContainer = clonedElement.querySelector('#metricDistribution_Container');
  if (metricDistributionContainer) {
    metricDistributionContainer.style.height = 'auto';
  }

  const legendTitles = clonedElement.querySelectorAll('.sol_leg_title');
  legendTitles.forEach((title) => {
    title.style.whiteSpace = 'normal'; // Allow text wrapping
    title.style.wordWrap = 'break-word'; // Break long words
    title.style.overflow = 'visible'; // Ensure no clipping of text
  });

  const targetClasses = [
    'top-performance-tbody',
    'bdc_panel.two-thirds.last',
    'panel_scroll_wrap',
    'bar-container',
    'vuec3-chart.bar-chart-canvas.c3',
    'c3-event-rect',
    'sol_legend',
    'bdc_panel.one-thirds',
    'donut-legend',
    'donut-legend-table-div',
    'donut-container.table',
    'donut-container.donut-legend-table-div',
  ];

  targetClasses.forEach((className) => {
    const elements = clonedElement.querySelectorAll(`.${className}`);
    elements.forEach((el) => {
      el.style.height = 'auto';
      el.style.maxHeight = 'none';
      el.style.textOverflow = 'visible';
    });
  });

  clonedElement.style.pageBreakInside = 'avoid'; // Prevent page break inside this element

  // Append the cloned element to a container
  const container = document.createElement('div');
  container.style.position = 'fixed';
  container.style.top = '0';
  container.style.left = '0';
  container.style.width = '100%';
  container.style.background = '#fff';
  container.style.zIndex = '-1';
  container.appendChild(clonedElement);

  document.body.appendChild(container);

  const opt = {
    margin: [10, 10, 12, 10], // Margins in mm
    filename: `export_${elementId}_${new Date().toISOString()}.pdf`,
    image: { type: 'jpeg', quality: 1.0 }, // High-quality images
    html2canvas: {
      scale: 2, // Increase scale for better quality
      logging: false, // Disable logging
      useCORS: true, // Allow cross-origin images
    },
    jsPDF: { unit: 'mm', format: 'a4', orientation },
  };

  html2pdf()
    .set(opt)
    .from(clonedElement)
    .toPdf()
    .get('pdf')
    .then(() => {})
    .save()
    .finally(() => {
      document.body.removeChild(container); // Clean up after PDF generation
    });
}

export function exportToPDFLineChart(elementId, orientation = 'landscape') {
  const element = document.getElementById(elementId);

  if (!element) {
    console.error(`Element with ID ${elementId} not found.`);
    return;
  }
  // Hide the modal if it exists
  const modal = element.querySelector('.download-options-modal');
  if (modal) {
    modal.style.display = 'none'; // Hide the modal
  }
  // Ensure that the chart is fully rendered
  const lineChart = element.querySelector('line-chart');
  if (lineChart) {
    // Trigger a chart update if using Chart.js or similar
    if (lineChart.$refs.chart) {
      lineChart.$refs.chart.chart.update();
    }
  }

  // Clone the element for PDF export
  const clonedElement = element.cloneNode(true);
  clonedElement.style.width = '100%'; // Landscape A4 width (210mm x 297mm)
  clonedElement.style.height = 'auto'; // Adjust height based on content
  clonedElement.style.fontSize = '12px'; // Adjust font size for better fit
  // Prevent components from splitting across pages
  clonedElement.style.pageBreakInside = 'avoid'; // Prevent page break inside the component

  // Style for the line chart container
  const lineChartContainer = clonedElement.querySelector('.line-chart-container');
  if (lineChartContainer) {
    lineChartContainer.style.pageBreakInside = 'avoid'; // Prevent page break inside the chart container
    lineChartContainer.style.width = '100%'; // Ensure it takes up full width
  }

  // Create a container to append the cloned element
  const container = document.createElement('div');
  container.style.position = 'fixed';
  container.style.top = '0';
  container.style.left = '0';
  container.style.width = '297mm'; // Landscape A4 width
  container.style.background = '#fff';
  container.style.zIndex = '-1';
  container.appendChild(clonedElement);

  document.body.appendChild(container);

  const opt = {
    margin: [10, 10, 10, 10], // Margins in mm
    filename: `export_${new Date().toISOString()}.pdf`,
    image: { type: 'jpeg', quality: 1.0 }, // High-quality images
    html2canvas: {
      scale: 2, // Increase scale for better quality
      logging: false, // Disable logging
      useCORS: true, // Allow cross-origin images
    },
    jsPDF: { unit: 'mm', format: 'a4', orientation },
  };

  html2pdf()
    .set(opt)
    .from(clonedElement)
    .toPdf()
    .get('pdf')
    .then(() => {})
    .save()
    .finally(() => {
      document.body.removeChild(container); // Clean up after PDF generation
    });
}

export function clearIndexedDBStore(dbName, storeName) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(dbName);

    request.onsuccess = (event) => {
      const db = event.target.result;
      const transaction = db.transaction([storeName], 'readwrite');
      const store = transaction.objectStore(storeName);

      const clearRequest = store.clear();

      clearRequest.onsuccess = () => {
        resolve();
      };

      clearRequest.onerror = () => {
        console.error(`Failed to clear data from store: ${storeName}`);
        reject(new Error(`Failed to clear data from store: ${storeName}`));
      };
    };

    request.onerror = () => {
      console.error(`Failed to open IndexedDB: ${dbName}`);
      reject(new Error(`Failed to open IndexedDB: ${dbName}`));
    };
  });
}

export function checkUserHasAiAssistant(user) {
  const userHasAiAssistant = user.userApplications.filter((item) =>
    item.applicationId === APPLICATION_AI_ASSISTANT_FULL_PLATFORM ? item : null
  );
  return !!userHasAiAssistant.length;
}

export function getErrorMessage(error, timeoutFlag) {
  if (error.response) {
    const status = error.response?.status;
    if (status >= 500 && status <= 599) {
      if (status === 504 && timeoutFlag) {
        return GENERIC_REPORT_GATEWAY_TIMEOUT_ERROR_MESSAGE;
      }
      return GENERIC_ERROR_MESSAGE;
    }
    return error.response?.data?.message || GENERIC_ERROR_MESSAGE;
  }
  if (error.request && timeoutFlag) {
    return GENERIC_REPORT_GATEWAY_TIMEOUT_ERROR_MESSAGE;
  }
  return GENERIC_ERROR_MESSAGE;
}

// get timestamp array saved from storage
export function getValidRunTimestamps(key) {
  const now = new Date().getTime();
  const timestampsStr = localStorage.getItem(key);

  if (!timestampsStr) {
    return []; // no runs yet
  }

  const allTimestamps = JSON.parse(timestampsStr);
  // filter out timestamps that already expired
  const validTimestamps = allTimestamps.filter((expiry) => expiry > now);
  // ff the array changed, update localStorage
  if (validTimestamps.length !== allTimestamps.length) {
    localStorage.setItem(key, JSON.stringify(validTimestamps));
  }
  return validTimestamps;
}

export function parseEnvNumber(envVar) {
  try {
    return parseInt(JSON.parse(envVar), 10);
  } catch (error) {
    return NaN;
  }
}

// Report builder 1 and 2 visibility is controlled by env variables. These functions check those variables to determine visibility in the app.
export function isRb1Visible() {
  return resolvedConfig.RB1_VISIBLE?.toLowerCase() === 'true';
}

export function isRb2Visible() {
  return resolvedConfig.RB2_VISIBLE?.toLowerCase() === 'true';
}

export function rb1VisibleToAdvertisers() {
  return resolvedConfig.RB1_VISIBLE_TO_ADVERTISERS
    ? resolvedConfig.RB1_VISIBLE_TO_ADVERTISERS.split(',')
        .map((id) => id.trim())
        .filter(Boolean)
    : [];
}

// Advertiser IDs (comma-separated env var) for which the Google Analytics tool is hidden.
export function gaToolHiddenForAdvertisers() {
  return resolvedConfig.GA_TOOL_HIDDEN_FOR_ADVERTISERS
    ? resolvedConfig.GA_TOOL_HIDDEN_FOR_ADVERTISERS.split(',')
        .map((id) => id.trim())
        .filter(Boolean)
    : [];
}

// Account IDs (comma-separated env var) for which the Agency Reports tool is shown.
export function agencyReportsVisibleToAccounts() {
  return resolvedConfig.AGENCY_REPORTS_VISIBLE_TO_ACCOUNTS
    ? resolvedConfig.AGENCY_REPORTS_VISIBLE_TO_ACCOUNTS.split(',')
        .map((id) => id.trim())
        .filter(Boolean)
    : [];
}

export function getAuthorizedDspUserList() {
  return resolvedConfig.AUTHORIZED_DSP_USERS
    ? resolvedConfig.AUTHORIZED_DSP_USERS.split(',')
        .map((id) => id.trim())
        .filter(Boolean)
    : [];
}

export function verifyRunCount(key, count = 0, sentryEntry = '') {
  // get the list of unexpired timestamps
  const validTimestamps = getValidRunTimestamps(key);
  const val = resolvedConfig.MAX_RUN_REPORT_COUNT;
  const maxRunReportCount = parseEnvNumber(val);
  console.log('maxRunReportCount', maxRunReportCount);
  const maxCount = count > 0 ? count : maxRunReportCount;
  // check if the user has reached the max limit of runs
  if (validTimestamps.length >= maxCount) {
    // console.log('Limit of max run count reached.');
    let src = 'Reports';
    if (sentryEntry.length > 0) {
      src = sentryEntry;
    }
    if (window.$sentry) {
      window.$sentry.captureException(`Max Run limit reached running -> ${src}`);
    }
    return true;
  }

  // add a new expiration timestamp for this new run
  const timeToLive = parseEnvNumber(resolvedConfig.STORAGE_TIME_TO_LIVE_IN_MS);
  console.log('timeToLive', timeToLive);
  const newExpiry = new Date().getTime() + timeToLive;
  validTimestamps.push(newExpiry);

  // save the entire updated array back to local storage
  localStorage.setItem(key, JSON.stringify(validTimestamps));
  return false;
}

export function deleteOldestTimestamp(key) {
  const timestamps = getValidRunTimestamps(key);

  if (timestamps.length === 0) {
    // console.log(`No active timestamps for key '${key}'. Nothing to delete.`);
    return null;
  }
  timestamps.sort((a, b) => a - b);
  const oldestTimestamp = timestamps.shift();
  localStorage.setItem(key, JSON.stringify(timestamps));
  // console.log(`Successfully deleted the oldest timestamp for key '${key}'.`);
  return oldestTimestamp;
}

/**
 * Fetches all features and updates the Vuex store.
 * @param {Object} store - The Vuex store instance.
 * @returns {Promise<void>}
 */
export async function loadAllFeatures(advertiserApi, store) {
  try {
    const response = await advertiserApi.getAllFeatures();
    store.set('common/features', response.data);
  } catch (error) {
    console.error('Error loading features:', error);
    throw error;
  }
}

const logger = {
  log: (...args) => {
    if (debug) {
      console.log(...args);
    }
  },
  warn: (...args) => {
    if (debug) {
      console.warn(...args);
    }
  },
  error: (...args) => {
    if (debug) {
      console.error(...args);
    }
  },
};

export function getInitials(str) {
  const words = str.trim().split(/\s+/); // Split by whitespace
  return words
    .slice(0, 2)
    .map((word) => word[0])
    .join('');
}

export default logger;
